module.exports = __webpack_public_path__ + "img/undraw_Online_information_re_erks.3d9d55ef.svg";